import { computed, DestroyRef, Directive, inject, input, OnInit, signal } from '@angular/core';
import { LassoSelectionDirective, OcrService, pointRect } from '@ps-gui/claims-terminal-extraction';
import { CtPage, ClaimsToastService, WordRect } from '@ps-gui/claims-terminal-shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[externalDocumentPreviewOcrSelection]',
  exportAs: 'ocrSelection',
})
export class ExternalDocumentPreviewOcrSelectionDirective implements OnInit {
  protected readonly boxSelection = inject(LassoSelectionDirective);
  protected readonly ocrService = inject(OcrService);
  protected readonly destroyRef = inject(DestroyRef);
  private readonly t = inject(ClaimsToastService);

  isOcrReady = input.required<boolean>();
  page = input.required<CtPage>();

  lasso = this.boxSelection.currentLasso;

  selectedWordRects = signal<WordRect[]>([]).asReadonly();

  ngOnInit(): void {
    this.boxSelection.lastReleasedLasso$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (!this.isOcrReady() || this.selectedWordRects().length === 0) return;

      const selectedWords = this.selectedWordRects().map((rect) =>
        this.ocrService.getWord(this.page().id, rect),
      );

      console.debug(selectedWords);
      navigator.clipboard.writeText(selectedWords.join(' ')).then(() => {
        this.t.success('bamana');
      });
    });

    this.selectedWordRects = computed(() => {
      if (!this.isOcrReady()) return [];

      const lasso =
        this.boxSelection.currentLasso() ?? pointRect(this.boxSelection.currentMousePosition());

      return this.ocrService.getWordsInRect(this.page().id, lasso);
    });
  }
}
